<div
  class="app-shell"
  [ngClass]="computedClasses()"
  (transitionstart)="onTransitionStart()"
  (transitionend)="onTransitionEnd($event)"
>
  <ng-content select="mop-navbar"></ng-content>

  <ng-content select="mop-side-nav"></ng-content>

  <main>
    <ng-content select="[mainContent]"></ng-content>
  </main>

  <ng-content select="mop-footer"></ng-content>
</div>
